export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20photograph%20of%20beautifully%20arranged%20lifestyle%20products%20including%20leather%20bags%2C%20scarves%2C%20watches%2C%20and%20accessories%20spread%20across%20a%20sunlit%20wooden%20table%2C%20warm%20afternoon%20light%20casting%20soft%20shadows%2C%20rich%20earthy%20tones%20with%20terracotta%20and%20olive%20accents%2C%20bohemian%20luxury%20editorial%20style%2C%20airy%20spacious%20composition&width=1920&height=800&seq=cta-main-v2-vb&orientation=landscape"
        alt="Start exploring the best VigorBuy Spreadsheet products today"
        title="Start Exploring VigorBuy Spreadsheet"
        className="absolute inset-0 w-full h-full object-cover object-top"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/55 to-black/75"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
          <div className="text-center lg:text-left">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3">
              Start Exploring the Best
              <br />
              <span className="text-accent-500">VigorBuy Spreadsheet</span> Today
            </h2>
            <p className="text-base text-white/70 max-w-md">
              Join thousands of shoppers who discover trusted products, verified sellers, and the best deals every day.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 bg-accent-500 text-background-50 rounded-full text-base font-semibold whitespace-nowrap hover:bg-accent-600 transition-all duration-300 cursor-pointer hover:scale-105 text-center"
            >
              Browse Spreadsheet <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-full text-base font-semibold whitespace-nowrap hover:bg-white/25 transition-all duration-300 cursor-pointer hover:scale-105 text-center"
            >
              Visit VigorBuy <i className="ri-external-link-line ml-2"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}